import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateTagMutationVariables = Types.Exact<{
  tagId: Types.Scalars['Int']['input'];
  tagName: Types.Scalars['String']['input'];
  market: Types.Scalars['String']['input'];
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTestimonialTag: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const UpdateTagDocument = gql`
    mutation UpdateTag($tagId: Int!, $tagName: String!, $market: String!) {
  updateTestimonialTag(
    request: {tagId: $tagId, tagName: $tagName, market: $market}
  ) {
    count
    error
  }
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      tagName: // value for 'tagName'
 *      market: // value for 'market'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;